import { render, staticRenderFns } from "./footer-sub-nav.vue?vue&type=template&id=19a90ddc&"
import script from "./footer-sub-nav.vue?vue&type=script&lang=js&"
export * from "./footer-sub-nav.vue?vue&type=script&lang=js&"
import style0 from "./footer-sub-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports